import { CompleteAddress } from '@dreryk/address-common-api';
import { CurrentHealthcareOrganizationUpdateCommand } from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { Regon } from '@dreryk/regon-common-api';
import { TaxIdentifier } from '@dreryk/tax-identifier-common-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { ActionBar, ButtonVariant, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { healthcareOrganizationTranslationKeys } from '../../../translations';

import {
   HealthcareOrganizationUpdateFormBean,
   HealthcareOrganizationUpdateFormController,
} from './HealthcareOrganizationUpdateForm';

type HealthcareOrganizationUpdateActionProps = Pick<HealthcareOrganizationUpdateFormController, 'handleSubmit'> & {
   readonly onDataChanged: VoidFunction;
};

export const HealthcareOrganizationUpdateAction = (props: HealthcareOrganizationUpdateActionProps): JSX.Element => {
   const { executeAsync: updateHealthcareOrganization } = useCqrsCommand<void, HealthcareOrganizationUpdateFormBean>(
      (parameters) => {
         const command = new CurrentHealthcareOrganizationUpdateCommand();
         command.registerBookNumber = parameters.registerBookNumber!;
         command.registeringAuthorityId = parameters.registeringAuthority!.id;
         command.name = parameters.name;
         command.phoneNumber = parameters.phoneNumber!;
         command.emailAddress = Choice.withUseDefaultIfNull(parameters.emailAddress);
         command.taxIdentifier = TaxIdentifier.of(parameters.taxIdentifier!);
         command.regon = Regon.of(parameters.regon!);
         command.address = CompleteAddress.builder()
            .withTown(parameters.city!)
            .withPostcode(parameters.postcode!)
            .withStreet(parameters.street)
            .withBuilding(parameters.house!)
            .withFlat(parameters.flat)
            .build();

         if (parameters.logo) {
            command.logo = parameters.logo;
         }

         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(healthcareOrganizationTranslationKeys.organizationDataChanged);
            props.onDataChanged();
         },
      }
   );

   return (
      <ActionBar.PrimaryButton
         testId='healthcareOrganizationUpdate'
         label={commonTranslationKeys.save}
         onClick={props.handleSubmit(updateHealthcareOrganization)}
         variant={ButtonVariant.PRIMARY}
         order={1}
         blockingOperation
      />
   );
};
